import { Container } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import iconApps from "../../assets/images/icon/icon.png";
import AuthRegisterForm from "../../components/auth/AuthRegisterForm";
import LanguageSwitcher from "../../components/LanguageSwitcher";
import { useTranslation } from "react-i18next";

const RegisterPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("auth");

  return (
    <>
      <Helmet>
        <title>{t("register.meta_title")}</title>
      </Helmet>
      <LanguageSwitcher placement="floating" syncServer={false} />
      <div className="center-content">
        <Container className="box-shadow">
          <img
            src={iconApps}
            alt={t("logo_alt")}
            style={{
              marginTop: "20px",
              marginBottom: "20px",
              width: "100px",
              display: "block",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          />

          <h2 className="text-center">{t("register.title")}</h2>
          <p className="text-center mb-3" style={{ fontSize: "11pt" }}>
            {t("register.subtitle")} <i>{t("register.subtitle_hint")}</i>
          </p>

          <Container>
            <AuthRegisterForm
              onSuccess={(response) =>
                navigate("/login", {
                  state: { message: response.message, fromRegistration: true },
                })
              }
              onRequireLogin={() => navigate("/login")}
              showGoogle
              registerSource="console"
            />
          </Container>
        </Container>
      </div>
    </>
  );
};

export default RegisterPage;
